module.exports = __webpack_public_path__ + "img/5.7ef3d472.jpg";